import { useCallback, useMemo } from "react";
import { useLocation } from "react-router";

import Box, { type BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface DrawerNavigationProps {
  items: { name: string; paths: string[] }[];
  pt?: BoxProps["pt"];
}

export function DrawerNavigation({ items, pt = 6 }: DrawerNavigationProps) {
  const { pathname } = useLocation();

  const currentStepIndex = useMemo(
    () =>
      items.findIndex(({ paths }) => {
        return paths.includes(pathname);
      }),
    [pathname, items]
  );

  const stepColor = useCallback(
    (stepIndex: number): "primary" | "textSecondary" | "inherit" => {
      if (currentStepIndex === stepIndex) {
        return "primary";
      }
      if (currentStepIndex < stepIndex) {
        return "textSecondary";
      }
      return "inherit";
    },
    [currentStepIndex]
  );

  return (
    <Box
      pt={pt}
      sx={{
        gridColumnStart: 2,
        gridColumnEnd: "span 3",
      }}
      display="flex"
      flexDirection="column">
      <Box sx={{ position: "fixed" }}>
        <Box display="flex" flexDirection="column">
          {items.map((item, index) => (
            <Typography
              key={item.paths[0]}
              sx={(theme) => ({
                padding: theme.spacing(0.5, 0),
              })}
              color={stepColor(index)}>
              {item.name}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
